import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';

import { DashboardSnakeCasePipe } from 'src/app/core/pipes/dashboard-snake-case/dashboard-snake-case.pipe';
import { BarsService } from 'src/app/dashboard/services/bars/bars.service';
import * as barActions from './bars.actions';

@Injectable()
export class BarEffects {
  deleteBar$ = createEffect(() =>
    this.actions$.pipe(
      ofType(barActions.deleteBar),
      switchMap(({ bar }) => {
        const barSnakeCase = this.dashboardSnakeCasePipe.keysToSnakeCase(bar);
        return this.barsService.deleteBar(barSnakeCase).pipe(
          map(() => barActions.deleteBarSuccess({ deletedBar: bar })),
          catchError((err: HttpErrorResponse) => of(barActions.deleteBarError({ err })))
        );
      })
    )
  );

  deleteBarSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(barActions.deleteBarSuccess),
        tap(({ deletedBar }) => this.toastrService.success('Bar deleted!'))
      ),
    { dispatch: false }
  );

  deleteBarError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(barActions.deleteBarError),
        tap(({ err }) => this.toastrService.error('Unable to delete bar'))
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private barsService: BarsService,
    private dashboardSnakeCasePipe: DashboardSnakeCasePipe,
    private toastrService: ToastrService
  ) {}
}
